import { gql } from "@apollo/client";

import { GRAPHQL_METHODS } from "../../utils/constants";
import { networkGraphqlRequest } from "../../utils/networkUtils";

const GET_COMPLAINTS = gql`
  query GetAllDemands($query: PaginationQuery!) {
    getAllDemand(query: $query) {
      page
      limit
      totalCount
      totalPages
      docs {
        demandIdentityByUser
        demandType
        complaintId: caseNumber
        business
        status {
          label
          category
        }
        area
        process
        document
        documentNumber
        country
        files
        region: departament
        reason
        currency
        amount
        details: detail
        request: order
        enterDate: date
        maxDate
        registerDate
        client: claimant {
          name: fullName
          documentType
          documentNumber
          phoneNumber: phone
          cellphoneNumber: cellPhone
          email
          charge: position
        }
        processInformation {
          id
          involvedAreas: areasInvolved
          affectedAreas: areasAffected
          clientType {
            client
            clientName
          }
          loadType
          label: loadContent
          executiveName: commercialExecutive
          requestVideo: videoSurveillance
          videoRequestDate: dateRequestVideo
          videoUploadDate: dateReceptionVideo
          processNumber: reviewProcess
          isIncidence: incidence
          incidenceDate
          traceabilityRequestDate: dateRequestTraceability
          traceabilityDeliveryDate: dateDeliveryTraceability
          responseDate: dateAnswerSent
        }
        resultInformation {
          compensation: indemnization
          compensationProcess: indemnizationProcedure
          responsibleForPayment: paymentResponsible
          paymentDate
          compensationFile: letterClientResponse
          socialReason: businessName
          bankAccount
          bank
          transactionDocument
          caseNumber
          lastAnswer {
            id
            approvalDate
            businessDays: attentionDays
            responseMedium
            observation: observer
            responseDays
            pending: pendingBy
            registerDate
          }
        }
      }
    }
  }
`;

function requestData(
  client,
  page,
  caseNumber,
  status,
  enterDate,
  area,
  clientName,
  category,
  networkOnly
) {
  const params = {
    query: {
      page,
      caseNumber,
      status,
      date: enterDate,
      area,
      clientName,
      category,
    },
  };
  return networkGraphqlRequest(
    GRAPHQL_METHODS.QUERY,
    client,
    GET_COMPLAINTS,
    params,
    networkOnly
  );
}

export default requestData;
